import { AvAnalytics, AvSplunkAnalytics } from '@availity/analytics-core';
import { avLogMessagesApiV2 } from '@availity/api-axios';

const avSplunkAnalytics = new AvSplunkAnalytics(avLogMessagesApiV2, true);

const avAnalytics = new AvAnalytics([avSplunkAnalytics], Promise, true, true, {
  recursive: true,
});

const sanitizeMessage = (message: unknown): string => {
  if (!message) return '';
  
  const messageStr = typeof message === 'string' ? message : String(message);
  return messageStr.replace(/token|session|cookie|auth|key|secret|password|credential/gi, '[REDACTED]');
};

export const trackEvent = (data: { event: string; status?: number; api?: string; level?: 'info' | 'error'; message?: string; [key: string]: unknown }) => {
  try {
    const sanitizedData = {
      ...data,
      message: data.message ? sanitizeMessage(data.message) : undefined,
    };
    
    avAnalytics.trackEvent({
      level: sanitizedData.level || 'info',
      applicationId: 'availity-developer-portal',
      ...sanitizedData,
    });
  } catch {
    // Silent fail
  }
};

export default trackEvent;
